/* eslint-disable no-irregular-whitespace */
<!-- =========================================================================================
  File Name: ClipboardDirective.vue
  Description: Clipboard demo
  ----------------------------------------------------------------------------------------
  Lighthouse - Cloudify Admin Panel
========================================================================================== -->

<template>
  <div>
    <collector ref="collector"></collector>
    <automationEditor ref="automationEditor"></automationEditor>
    <div id="colors-demo">
      <div id="loading-demo">
        <vx-card title="Account API Key" subtitle="Use api key to carry out custom automations">
          <vs-input v-model="apiKey" class="inline-flex mb-2 mr-2" />
          <vs-button v-clipboard:copy="apiKey" v-clipboard:success="onCopy" v-clipboard:error="onError"> Copy </vs-button>
        </vx-card>
        <!-- Section for Connected Application and Active Workflows -->
        <vx-card v-if="tag !== 'Lighthouse'" title="Connected Applications" subtitle="Connected applications in your account">
          <vs-row vs-type="flex" vs-justify="space-around" vs-align="flex-start">
            <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12">
              <vs-card v-if="Object.keys(apps).length > 0">
                <ul class="demo-alignment text-white">
                  <template v-for="(app, index) in Object.values(apps)">
                    <vx-tooltip :key="index" :color="app.active ? 'success' : 'danger'" :text="getAppTooltipText(app)">
                      <li style="cursor: pointer" :class="app.active ? '' : 'bg-warning-gradient'">
                        <a @click="addHash(app)"><img :src="withCMSBase(app.logo.data.attributes.url)" height="80" width="80" /></a>
                      </li>
                    </vx-tooltip>
                  </template>
                </ul>
              </vs-card>
              <vs-alert v-else active="true" color="warning"> No apps connected to your account </vs-alert>
            </vs-col>
          </vs-row>
        </vx-card>
        <past-invoices />
        <payment-methods />
        <vx-card title="Ongoing Automations">
          <vs-tabs>
            <vs-tab label="Simplified View">
              <div class="demo-alignment">
                <ul class="demo-alignment text-white" v-for="(automation, index) in Object.keys(sheets)" :key="index">
                  <li
                    style="cursor: pointer"
                    @click="automationActionPrompt(automation, sheets[automation])"
                    :class="`bg-${defaultColors[Math.floor(Math.random() * 6)]}`"
                  >
                    <vx-tooltip :text="sheets[automation].tooltip ? sheets[automation].tooltip : 'No Description Found'">
                      <p class="m-2 text-sm">{{ automation }}</p>
                    </vx-tooltip>
                  </li>
                </ul>
              </div>
            </vs-tab>
            <vs-tab label="Detailed View">
              <div>
                <vs-table :hoverFlat="false" :noDataText="noData">
                  <template slot="thead">
                    <vs-th> Automation Name </vs-th>
                    <vs-th> Description </vs-th>
                    <vs-th>Trigger</vs-th>
                    <vs-th>Action</vs-th>
                    <vs-th :class="classes"> Open Automations </vs-th>
                    <vs-th> Edit Settings</vs-th>
                  </template>

                  <template>
                    <vs-tr :key="index" v-for="(automation, index) in Object.keys(sheets)">
                      <vs-td :data="sheets[automation].tooltip">
                        {{ automation }}
                      </vs-td>

                      <vs-td v-if="sheets[automation].tooltip !== undefined && sheets[automation].tooltip.length > 0">
                        {{ sheets[automation].tooltip }}
                      </vs-td>
                      <vs-td v-else> No Description Found </vs-td>

                      <vs-td v-if="sheets[automation].trigger !== undefined">
                        {{ appNames[Object.keys(sheets[automation].trigger)[0]] }}
                        ⮞
                        {{ sheets[automation].trigger[Object.keys(sheets[automation].trigger)[0]] }}
                      </vs-td>
                      <vs-td v-else> No Trigger Found </vs-td>

                      <vs-td v-if="sheets[automation].action !== undefined">
                        {{ appNames[Object.keys(sheets[automation].action)[0]] }}
                        ⮞
                        {{ sheets[automation].action[Object.keys(sheets[automation].action)[0]] }}
                      </vs-td>
                      <vs-td v-else> No Action Found </vs-td>

                      <vs-td v-if="sheets[automation].assignee" :class="classes">
                        {{ sheets[automation].assignee }}
                      </vs-td>

                      <vs-td v-else :class="classes"> --- </vs-td>

                      <vs-td>
                        <vs-button @click="automationDetails(automation)" icon="timeline" color="success" type="flat">Open</vs-button>
                      </vs-td>
                      <vs-td>
                        <vs-button @click="automationActionPrompt(automation, sheets[automation])" type="flat" color="dark" icon="edit">Edit</vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import VxCard from '../../components/vx-card/VxCard.vue'
import collector from './user-settings/credentialsManager/credentialsCollector.vue'
import automationEditor from './user-settings/automationsManager/automationEditor.vue'
import { credentialsValidity } from './user-settings/credentialsManager/credentialsValidity'
import { appNames } from './user-settings/constants/appNames'
import axios from 'axios'
import { getBPMTsAuthUrl, getApiKey, geLighthouseUrl, getLighthouseSupportedAppsUrl } from '@/utils/misc'
import { AUTH_TYPES } from '@/constant'
import PaymentMethods from '../PricingSection/PaymentMethods.vue'
import PastInvoices from '../PricingSection/PastInvoices.vue'

export default {
  name: 'SettingsComponent',
  components: { VxCard, collector, automationEditor, PaymentMethods, PastInvoices },
  data() {
    return {
      pageLoaded: false,
      sheets: [],
      apps: {},
      databaseApplication: {},
      defaultColors: ['primary', 'success', 'danger', 'warning', 'primary', 'success', 'danger', 'warning'],
      selectedAssignee: 'am@cloudify.biz',
      appNames,
      sourceFilter: { label: 'All', value: 'All' },
      sourceOptions: [{ label: 'All', value: 'All' }],
      showEditPrompt: false,
      currentAutomationName: '',
      currentAutomationData: {},

      statusFilter: { label: 'All', value: 'All' },
      statusOptions: [
        { label: 'All', value: 'All' },
        { label: 'Success', value: 'success' },
        { label: 'Failed', value: 'failed' },
        { label: 'Ongoing', value: 'ongoing' },
      ],
      automationFilter: { label: 'All', value: 'All' },
      automationOptions: [{ label: 'All', value: 'All' }],

      issueFilter: { label: 'All', value: 'All' },
      issueOptions: [{ label: 'All', value: 'All' }],
      hubspotPipelineChangeFlag: false,
      allAppsValidated: true,
      noData: '',
      tag: '',
      firstLoad: true,
    }
  },
  computed: {
    // Computed property to get and populate firestore data if any new data is added
    getFirestoreData() {
      const fetchedData = this.pageLoaded && this.$store.state.DB
      if (fetchedData) {
        this.popualateFirebaseData(fetchedData)
      }
      return {
        datapopulated: true,
      }
    },
    apiKey() {
      return JSON.parse(localStorage.getItem('userInfo')).uid
    },
    classes() {
      if (!this.$store.state.admin.access) {
        return 'automation-not-visible'
      }
      return ''
    },
  },
  watch: {
    // This will trigger when there is an update or addition in firestore database
    getFirestoreData: {
      handler(newValue) {
        return newValue
      },
    },
  },
  methods: {
    // this method will add data from firestore and assign them for Settings page
    async popualateFirebaseData(fetchedData) {
      const cmsApps = await this.getCMSApps()

      this.tag = fetchedData.user.tag.type
      this.sheets = fetchedData.sheets
      if (Object.keys(JSON.parse(JSON.stringify(fetchedData.sheets))).length === 0) {
        this.noData = 'No Data Available'
      } else {
        this.noData = ''
      }
      this.servicesSubscribed = fetchedData.servicesSubscribed
      this.databaseApplication = fetchedData.credentials
      this.hubspotPipelineChangeFlag = fetchedData.hubspotPipelineChangeFlag
      this.allAppsValidated = true
      for (const cmsApp of cmsApps) {
        const credentials = this.databaseApplication[cmsApp.attributes.slug]
        if (credentials) {
          const isActive = credentialsValidity(cmsApp, credentials)
          this.apps[cmsApp.attributes.slug] = {
            ...cmsApp.attributes,
            firebaseData: credentials,
            active: isActive,
            fieldsRequired: this.getFieldsValues(cmsApp.attributes.fieldsRequired, credentials),
          }
          if (!isActive) this.allAppsValidated = false
        }
      }
      // Ugly workaround to make sure we open auth box only after all apps are loaded once.
      if (this.firstLoad) {
        this.firstLoad = false
        this.openIfHash()
      }
      if (this.allAppsValidated === true && this.hubspotPipelineChangeFlag === false) await this.hubspotPipelineChange(fetchedData.user.email)
    },
    /**
     * @description - Open the authentication dialog when app exists after hash.
     */
    openIfHash() {
      if (!this.$route.hash) return
      const hashApp = this.$route.hash.replace('#', '')
      if (hashApp in this.apps) {
        this.appsAuthentication(this.apps[hashApp])
      } else {
        this.$router.replace({ name: 'Settings' })
      }
    },
    /**
     * @description - Add app after hash to the url & open the app authentication dialog.
     */
    async addHash(app) {
      if (this.$route.hash !== `#${app.slug}`) {
        await this.$router.replace({
          name: 'Settings',
          hash: `#${app.slug}`,
        })
      }
    },

    getAppTooltipText(app) {
      if (app.authType === AUTH_TYPES.OAUTH2) {
        return `${app.name} : ${app.active ? 'Oauth Successful' : 'Oauth Not Done Yet'}`
      } else if (app.authType === AUTH_TYPES.CREDENTIALS) {
        return `${app.name} : ${app.active ? 'Credentials Added' : 'Credentials Missing'}`
      } else return `${app.name} : ${app.active ? 'Connected Successful' : 'App Not Connected Yet'}`
    },

    async getCMSApps() {
      try {
        return (await axios.get(getLighthouseSupportedAppsUrl())).data.data || []
      } catch (e) {
        this.$rollbar.error('Unable to fetch lighthouse supported apps', e)
        return []
      }
    },

    // This method is used to add authentication for a application.
    appsAuthentication(app) {
      if (app && app.launched) {
        this.toggleAppSettingsBox(app, this.credentialsCollected, this.authCancelled)
      } else {
        this.comingSoonNotification()
      }
    },

    authCancelled() {
      this.$router.replace({ name: 'Settings' })
    },

    credentialsCollected(app) {
      this.$router.replace({ name: 'Settings' })
      if (app.authType === AUTH_TYPES.OAUTH2) this.oauthWindowOpener(app)
      else if (app.authType === AUTH_TYPES.CUSTOM) this.customAuthOpener(app)
    },

    customAuthOpener(app) {
      if (app.authUrl) {
        this.$vs.loading()
        window.open(app.authUrl, '_self')
        this.$rollbar.info(`${app.slug} Custom Auth Process Started`, {
          data: {},
        })
      } else {
        this.$rollbar.warning(`${app.slug} Can't do custom auth as auth url is missing.`, {
          data: {},
        })
        this.$vs.notify({
          title: "Can't proceed",
          text: "This app can't be connected. Please contact support.",
          color: 'warning',
          iconPack: 'feather',
          position: 'top-center',
          icon: 'icon-alert-circle',
        })
      }
    },

    async oauthWindowOpener(app) {
      this.$vs.loading()
      window.open(
        getBPMTsAuthUrl({
          apiToken: getApiKey(),
          appName: app.slug,
          frontUrl: geLighthouseUrl('/settings'),
        }),
        '_self'
      )
      this.$rollbar.info(`${app.slug} Oauth Process Started`, {
        data: {},
      })
    },

    getFieldsValues(fieldsRequired, credObject) {
      return fieldsRequired.map((field) => {
        return {
          ...field,
          value: credObject[field.key] || field.defaultValue || '',
        }
      })
    },
    // Get all the apps form firestore that are available for the target user.
    async getApps() {
      this.$vs.loading.close()
      const fetchedData = this.$store.state.DB
      await this.popualateFirebaseData(fetchedData)
    },
    automationDetails(obj) {
      this.$router.push('/database/automations').catch(() => {})
      sessionStorage.setItem('source', 'All')
      sessionStorage.setItem('automation', obj)
    },
    onCopy() {
      this.$vs.notify({
        title: 'Success',
        text: 'API key copied successfully',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle',
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Failed',
        text: 'Error in copying text',
        color: 'danger',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-alert-circle',
      })
    },
    async toggleAppSettingsBox(app, updateCallback, cancelCallback) {
      if (app) {
        await this.$refs.collector.credentialsCollector(app, updateCallback, cancelCallback, app.authType === AUTH_TYPES.CREDENTIALS)
      }
    },
    automationActionPrompt(sheetName, sheetData) {
      this.$refs.automationEditor.editAutomationDetails(sheetName, sheetData)
    },
    comingSoonNotification() {
      this.$vs.notify({
        title: 'Coming Soon',
        text: 'This app will be available soon for use.',
        color: 'dark',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-alert-circle',
      })
    },
    async hubspotPipelineChange(email) {
      try {
        const axiosRes = await axios.post('https://marketplace-onboarding.cloudify-clients.autocode.gg/a2Flow/', {
          email: `${email}`,
          updatePipeline: true,
          msg: 'credentials received from user',
        })
        if (axiosRes.status === 200) {
          await firebase
            .firestore()
            .collection('cloudify')
            .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
            .update({ hubspotPipelineChangeFlag: true })
        }
        this.$rollbar.info('A2Flow Execurted Successfully', { data: {} })
      } catch (error) {
        this.$rollbar.error('A2Flow Execution Failed', { error })
      }
    },
  },
  created() {
    this.$vs.loading()
    setTimeout(() => {
      this.getApps()
      this.$vs.loading.close()
      this.pageLoaded = true
    }, 2000)
  },
}
</script>

<style scoped>
.assigneeInputField {
  width: 100%;
  margin-top: 1em;
}
.oauthButton {
  width: 100%;
  margin: 0.5em 0 0.5em 0;
}
.oauthRemoveDivider {
  margin-top: 1em;
}
.automation-not-visible {
  display: none;
}
</style>

<style lang="scss">
@import '@/assets/scss/vuexy/pages/colors.scss';
@import '@/assets/scss/vuexy/pages/loading.scss';
</style>
